import { countryLookup } from "./countries";
import { nanoid } from "nanoid";

export const formatAddress = (shippingOrBillingAddress, short = false) => {
  if (!shippingOrBillingAddress) {
    return "-";
  }
  const address1 = shippingOrBillingAddress.address_1 || "";
  const address2 = shippingOrBillingAddress.address_2 || "";
  const postalCode = shippingOrBillingAddress.postal_code || "";
  const city = shippingOrBillingAddress.city || "";
  const province = shippingOrBillingAddress.province || "";
  const countryCode = shippingOrBillingAddress.country_code || "";
  const countryName = countryCode ? countryLookup(countryCode) : "";

  let address = [address1, address2, city, province, countryName, postalCode];
  if (short) {
    address = [city, province, countryName];
  }
  address = address.filter((x) => x != "");
  return address.join(", ");
};

export const addProtocol = (url, { https = true } = {}) => {
  if (typeof url !== "string") {
    throw new TypeError(`Expected \`url\` to be of type \`string\`, got \`${typeof url}\``);
  }

  url = url.trim();

  if (/^\.*\/|^(?!localhost)\w+?:/.test(url)) {
    return url;
  }

  return url.replace(/^(?!(?:\w+?:)?\/\/)/, https ? "https://" : "http://");
};

export function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}

const symbols = {
  lt: "<",
  gt: ">",
  gte: ">=",
  lte: "<=",
  eq: "=",
  neq: "!=",
};

export const filterParser = (obj) => {
  let qstr = "";
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    // AND relation
    let temp = "";
    let option = obj[keys[i]]; //filter value
    const opKey = keys[i].toLowerCase(); // filter keys
    if (option == null) {
      temp = `(${opKey} NOT EXISTS)`;
    } else if (typeof option == "string") {
      option = option.replaceAll("'", "\\'");
      const formattedValue = isNaN(Number(option)) ? `'${option}'` : Number(option);
      temp = `(${opKey}=${formattedValue})`;
    } else if (typeof option == "object" && option.length > 0 && typeof option[0] == "string") {
      //{key:[value1,value2]}
      let temp2 = "";
      for (let j = 0; j < option.length; j++) {
        // OR relation for array type value
        option[j] = option[j].replaceAll("'", "\\'");
        const formattedValue = isNaN(Number(option[j])) ? `'${option[j]}'` : Number(option[j]);
        temp2 = appendOr(temp2, `(${opKey}=${formattedValue})`);
      }
      temp = temp2;
    } else if (
      //{key:{eq:"sd",lt:"cc"}}
      // deal with price filter{price:[0,25]}
      typeof option == "object"
    ) {
      const vkeys = Object.keys(option);
      let temp2 = "";
      for (let j = 0; j < vkeys.length; j++) {
        if (symbols.hasOwnProperty(vkeys[j])) {
          let formattedValue = `'${option[vkeys[j]]}'`;
          if (!isNaN(Number(option[vkeys[j]])) && typeof option[vkeys[j]] == "string") {
            formattedValue = Number(option[vkeys[j]]);
            temp2 = `(${opKey}${symbols[vkeys[j]]}${formattedValue})`;
            temp2 = appendAnd(temp, temp2);
          } else if (typeof option[vkeys[j]] == "object") {
            let temp3 = "";
            for (let k = 0; k < option[vkeys[j]].length; k++) {
              temp3 = `(${opKey}${symbols[vkeys[j]]}${option[vkeys[j]][k]})`;
              if (vkeys[j] == "neq") {
                temp2 = appendAnd(temp2, temp3);
              } else {
                temp2 = appendOr(temp2, temp3);
              }
            }
            temp2 = appendAnd(temp, temp2);
          } else {
            temp2 = `(${opKey}${symbols[vkeys[j]]}${formattedValue})`;
            temp2 = appendAnd(temp, temp2);
          }
        }
      }
      temp = temp2;
    }
    qstr = appendAnd(qstr, temp);
  }
  return qstr;
};

function appendAnd(str, append) {
  if (str == "") {
    return `${append}`;
  } else {
    return `(${str}) AND ${append}`;
  }
}

function appendOr(str, append) {
  if (str == "") {
    return `${append}`;
  } else {
    return `(${str}) OR ${append}`;
  }
}

export const sortParser = (str) => {
  if (str && typeof str == "string") {
    if (str.startsWith("-")) {
      return str.slice(1) + ":desc";
    } else {
      return str + ":asc";
    }
  }
};

function formatRangePrice(option, prefix) {
  let temp = "";
  if (option.length == 1) {
    // only one element
    if (option[0] != undefined) {
      temp = `(${prefix}  >= ${option[0]})`;
    }
  } else {
    // two elements
    if (option[0] != undefined && option[1] == undefined) {
      //[xx]=> value>=xx
      temp = `(${prefix}  >= ${option[0]})`;
    } else if (option[0] == undefined && option[1] != undefined) {
      //[,xx]=> value<=xx
      temp = `(${prefix}  <= ${option[0]})`;
    } else if (option[0] != undefined && option[1] != undefined) {
      //[xx,yy]=> value>=xx and value<=yy
      temp = `(${prefix}  >= ${option[0]} AND ${prefix}  <= ${option[1]})`;
    }
  }
  return temp;
}

export const compare = (a, b, key) => {
  let isAscOrder = true;
  if (key.startsWith("-")) {
    key = key.slice(1);
    isAscOrder = false;
  }
  if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
    return 0;
  }
  let x = a[key];
  let y = b[key];
  if (typeof a[key] == "string") {
    x = a[key].toLowerCase();
  }
  if (typeof b[key] == "string") {
    y = b[key].toLowerCase();
  }

  if (x < y) {
    return isAscOrder ? -1 : 1;
  }
  if (x > y) {
    return isAscOrder ? 1 : -1;
  }
  return 0;
};

export const isInPortfolio = (id, portfolio_content) => {
  if (!portfolio_content || !id || typeof portfolio_content != "object") {
    return false;
  }

  const slots = Object.keys(portfolio_content);
  for (let i = 0; i < slots.length; i++) {
    let contents = portfolio_content[slots[i]];
    if (typeof contents != "object") {
      return false;
    }
    for (let j = 0; j < contents.length; j++) {
      if (contents[j]?.id == id) {
        return slots[i];
      }
    }
  }
  return false;
};

//true: means user can edit
//false: means read only
export const checkPermission = (id, gid, permissionMap) => {
  if (id && permissionMap[id] == "WRITE") {
    return true;
  } else if (id && permissionMap[id] == "READ") {
    return false;
  } else {
    if (!gid) {
      return false;
    }
    //check collection
    if (permissionMap[gid] == "WRITE") return true;
    else if (permissionMap[gid] == "READ") return false;
    else {
      return false;
    }
  }
};

export const isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(
    !window["safari"] || (typeof window?.safari !== "undefined" && window?.safari.pushNotification)
  );

export const matchResourceUrl = (item = {}) => {
  if (item?.resourceType == "style") {
    return `/workspace/styles-master?id=${item.id}`;
  } else if (item?.resourceType == "moodboard") {
    return `/workspace/moodboard?id=${item.id}`;
  } else if (item?.resourceType == "project") {
    return `/produce/all-projects?id=${item.id}`;
  } else if (item?.resourceType == "collection") {
    return `/workspace/collections?id=${item.id}`;
  } else {
    return "";
  }
};

//convert  database schema calendar event obj
export const convertDbToEvent = (input, userId) => {
  let event = {
    id: input?.id,
    start: new Date(input.start_time),
    end: new Date(input.end_time),
    title: input.title,
    backgroundColor: input.color,
    extendedProps: {
      content: input?.content || {},
      type: input?.type,
      calendar_id: input?.calendar_id,
      status: input?.status,
      owner_id: input?.owner_id,
    },
    allDay: input?.content?.allDay,
    editable: input?.owner_id == userId || !userId,
  };
  return event;
};

//convert calendar event obj to database schema
export const convertEventDb = (event) => {
  let db = {
    id: event?.id,
    start_time: event.start,
    end_time: event.end,
    title: event.title,
    color: event.backgroundColor,
    content: {
      ...event?.extendedProps?.content,
      allDay: event?.allDay,
    },
    type: event?.extendedProps?.type,
    calendar_id: event?.extendedProps?.calendar_id,
    status: event?.extendedProps?.status,
  };
  return db;
};

export const getAllPostImages = (post, id = null) => {
  const content = post?.metadata?.content || [];
  const images = [];
  for (let i = 0; i < content.length; i++) {
    if (content[i]?.img?.url) {
      if (id) {
        if (content[i]?.resource_id == id) {
          images.push(content[i]?.img);
        }
      } else {
        images.push(content[i].img);
      }
    } else if (content[i]?.type == "grid") {
      const gridContent = content[i]?.content || [];

      for (let j = 0; j < gridContent.length; j++) {
        if (gridContent[j]?.img?.url) {
          if (id) {
            if (gridContent[j]?.resource_id == id) {
              images.push(gridContent[j].img);
            }
          } else {
            images.push(gridContent[j].img);
          }
        }
      }
    } else if (content[i]?.type == "column") {
      const gridContent = content[i]?.content || [];

      for (let j = 0; j < gridContent.length; j++) {
        if (gridContent[j]?.img?.url) {
          if (id) {
            if (gridContent[j]?.resource_id == id) {
              images.push(gridContent[j].img);
            }
          } else {
            images.push(gridContent[j].img);
          }
        }
      }
    }
  }
  return images;
};

//isDelete: delete the item in post by id
//isClear: clear the item in post and give a new id
export const handleUpdatePostContent = (post, item, isDelete = false, isClear = false) => {
  let oldContent = post?.metadata?.content || [];
  let newContent = [...oldContent];
  for (let i = 0; i < newContent.length; i++) {
    if (newContent[i]?.id == item.id) {
      if (isDelete) {
        if (isClear) {
          newContent[i] = { id: nanoid() };
        } else {
          newContent.splice(i, 1);
        }
      } else {
        newContent[i] = item;
      }
    } else if (newContent[i]?.content && newContent[i].content.length > 0) {
      for (let j = 0; j < newContent[i].content.length; j++) {
        let children = newContent[i].content[j];
        if (children?.id == item.id) {
          if (isDelete) {
            if (isClear) {
              newContent[i].content[j] = { id: nanoid() };
            } else {
              newContent[i].content.splice(j, 1);
            }
          } else {
            newContent[i].content[j] = item;
          }
        } else if (
          newContent[i].content[j]?.content &&
          newContent[i].content[j].content.length > 0
        ) {
          for (let k = 0; k < newContent[i].content[j].content.length; k++) {
            if (newContent[i].content[j].content[k]?.id == item.id) {
              if (isDelete) {
                if (isClear) {
                  newContent[i].content[j].content[k] = { id: nanoid() };
                } else {
                  newContent[i].content[j].content.splice(k, 1);
                }
              } else {
                newContent[i].content[j].content[k] = item;
              }
            }
          }
        }
      }
    }
  }

  const newPostData = {
    ...post,
    metadata: {
      ...post?.metadata,
      content: newContent,
    },
  };

  return newPostData;
};
